(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/leaguegames/assets/javascripts/views/statleaguegames.js') >= 0) return;  svs.modules.push('/components/statistics/leaguegames/assets/javascripts/views/statleaguegames.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.views = svs.statistics.views || {};
  svs.statistics.data = svs.statistics.data || {};

  var logger = new svs.core.log.Logger('svs.statistics.views.StatLeagueGames');

  svs.statistics.views.StatLeagueGames = svs.statistics.views.StatBase.extend({
    tagName: 'div',

    classId: 'StatLeagueGames',

    events: {
      'click .list-group-item': 'clicked',
      'change #matchesDateFilter': 'selectMenu',
      'focus #matchesDateFilter': 'focusMenu',
      'blur #matchesDateFilter':
        'blurMenu' 
    },

    loadingMore: false, 

    initialize: function(options) {
      options = _.extend({}, options);
      if (this.options.params && _.has(this.options.params, 'bigNavRef')) {
        this.bigNavRef = options.params.bigNavRef;
      }

      if (!options.params.leagueId) {
        return;
      }

      this.errorMessage = '';

      this.matchViews = {};

      _.bindAll(
        this,
        'onModelChange',
        'onLeagueModelChange',
        'onTryAgainClick'
      );

      this.initModel(options);
      this.initLeagueModel(options);
      this.initFilters();
      this.initListeners();

      if (
        !!(((svs.statistics || {}).data || {}).leagueModels || {}).matches &&
        !svs.statistics.data.leagueModels.matches.error
      ) {
        this.initMatchViews();
        logger.debug('Using pre-fetched model.');
      } else {
        this.fetch();
        logger.debug('No model pre-fetched, fetching model.');
      }
    },

    initFilters: function() {
      this.filters = {
        matchesDateFilter: {
          filterValues: {},
          selectedKey: ''
        }
      };
    },

    initModel: function(options) {
      var leagueId = options.params && options.params.leagueId,
        sportId = options.params && options.params.sportId;

      this.model = new svs.statistics.models.StatLeagueGames({
        leagueId: leagueId,
        sportId: sportId
      });
    },

    initLeagueModel: function(options) {
      var league = options.params && options.params.league,
        leagueId = options.params && options.params.leagueId;

      if (league && league instanceof svs.statistics.models.League) {
        this.leagueModel = options.params.league;
        logger.debug('Using provided league model.');
      } else {
        this.leagueModel = new svs.statistics.models.League({
          leagueId: leagueId
        });
        this.leagueModel.fetch();
        logger.debug('No league model provided, fetching model.');
      }
    },

    initListeners: function() {
      if (this.model) {
        this.listenTo(this.model, 'change', this.onModelChange);
        this.listenTo(this.model, 'error', this.onModelError);
      } else {
        logger.warn('No model available.', this);
      }

      if (this.leagueModel) {
        this.listenTo(this.leagueModel, 'change', this.onLeagueModelChange);
      } else {
        logger.warn('No league model available.', this);
      }
    },

    initScrollListener: function() {
      if (this.interval) {
        return;
      }

      this.interval = window.setInterval(
        function() {
          if (this.model.get('morePages') === false) {

            this.removeScrollListener();
          } else {
            if (
              !this.model.isExpanding &&
              this.isElementInViewport(
                this.$('.js-league-games-load-more-matches')
              )
            ) {
              this.showLoader();
              this.model.expandSelection();
            }
          }
        }.bind(this),
        250
      );
    },

    removeScrollListener: function() {
      if (!this.interval) {
        return;
      }

      window.clearInterval(this.interval);
      this.interval = null;
    },

    fetch: function() {
      this.showLoader();
      this.model.fetch();
    },

    onModelChange: function() {
      this.initMatchViews();
      this.render();
    },

    onLeagueModelChange: function() {
      this.render();
    },

    onModelError: function() {
      this.renderError();
    },

    initMatchViews: function() {
      var dates = this.model.getMatchesGroupedByDate(),
        self = this;

      _.each(dates, function(matches, index) {
        _.each(matches, function(match) {
          var id = 'v' + match.get('matchId'),
            view = self.matchViews[id];

          if (!view) {
            view = new svs.statistics.views.Match({
              modelReference: match,
              templateReference: svs.statistics.leaguegames.templates.match,
              index: index,
              styleClass: 'list-group-item-match',
              subscribe: {
                odds: true,
                draws: true
              }
            });

            self.matchViews[id] = {
              view: view,
              rendered: false
            };
          } else {
          }
        });
      });

      this.initScrollListener();
    },

    populateFilters: function() {
      if (_.isEmpty(this.filters.matchesDateFilter.filterValues)) {
        var leagueStartDate, leagueEndDate;
        leagueStartDate = moment();
        leagueEndDate = moment().set('year', 1900);
        var league = this.leagueModel.get('league');
        if (league) {
          if (league.type === 'normal') {
            leagueStartDate = moment(league.season.startDate);
            leagueEndDate = moment(league.season.endDate);
          }
          _.each(league.underlyingLeagues, function(ul) {
            leagueStartDate = moment.min(
              leagueStartDate,
              moment(ul.season.startDate)
            );
            leagueEndDate = moment.max(
              leagueEndDate,
              moment(ul.season.endDate)
            );
          });
        } else if ((this.model.get('matches')[0] || {}).league) {
          leagueStartDate = moment(
            this.model.get('matches')[0].league.season.startDate
          );
          leagueEndDate = moment(
            this.model.get('matches')[0].league.season.endDate
          );
        } else {
          leagueStartDate = moment().startOf('year');
          leagueEndDate = moment().endOf('year');
        }

        if (
          this.model.get('sportId') ===
          _.invert(svs.sport.theme.data.mapping.sport)['sport-hockey']
        ) {
          this.populateWeekFilter(leagueStartDate, leagueEndDate);
          this.errorMessage = 'Inga matcher ';
        } else {
          this.populateMonthFilter(leagueStartDate, leagueEndDate);
          this.errorMessage = 'Inga matcher i ';
        }
      }
    },

    render: function() {
      logger.debug('Rendering', Date.now());

      this.hideLoader();

      if (!this.model) {
        this.$el.html(
          svs.statistics.statistics.templates.nodata({
            renderEmpty: this.options.params.preDraw
          })
        );
        return this;
      }

      this.populateFilters();

      var matchesByDate = this.model.getMatchesGroupedByDate();

      var templateData = {
        matches: matchesByDate,
        filters: this.filters,
        errorMessage: {
          message:
            this.errorMessage +
            this.filters.matchesDateFilter.filterValues[
              this.filters.matchesDateFilter.selectedKey
            ].name
        }
      };

      this.$el.html(
        svs.statistics.leaguegames.templates.statleaguegames(templateData)
      );

      this.renderMatches();

      if (Object.prototype.hasOwnProperty.call(this.options.params, 'parent')) {
        this.options.params.parent.trigger('resize');
      }

      this.loadingMore = false;

      return this;
    },

    renderMatches: function() {
      var self = this;

      _.each(this.matchViews, function(viewCache) {
        var view = viewCache.view,
          index = view.options.index,
          rendered = viewCache.rendered,
          $element = self.$('#list-group-' + svs.utils.url.encode(index));

        view.delegateEvents();

        if (!rendered) {
          $element.append(view.render().el);
          viewCache.rendered = true;
        } else {
          $element.append(view.el);
        }
      });
    },

    renderError: function() {
      this.hideLoader();
      this.$el.html(svs.statistics.statistics.templates.tryagain({}));
      this.$('.js-statistics-reload').on('click', this.onTryAgainClick);

      return this;
    },

    onTryAgainClick: function() {
      this.$('.js-statistics-reload').off();
      this.showLoader();
      this.fetch();
    },

    disposeMatchViews: function() {
      _.each(this.matchViews, function(viewCache) {
        viewCache.view.dispose();
        viewCache.view.destroy();
      });

      this.matchViews = {};

      logger.debug(
        'Disposed ' + _.keys(this.matchViews).length + ' match views.'
      );
    },

    populateMonthFilter: function(startDate, endDate) {
      this.filters.matchesDateFilter.filterValues[0] = {
        name: 'Aktuellt',
        selectedName: 'Aktuellt',
        selected: true
      };
      this.filters.matchesDateFilter.selectedKey = 0;
      var d = startDate;
      var m;
      while (d.isBefore(endDate)) {
        if (d.month() !== m) {
          m = d.month();
          var monthName = d.format('MMM YYYY');
          monthName = monthName.charAt(0).toUpperCase() + monthName.slice(1);
          this.filters.matchesDateFilter.filterValues[d.format('YYYYMM')] = {
            name: monthName,
            selectedName: monthName,
            selected: false
          };
        }
        d.add(1, 'd');
      }
    },

    populateWeekFilter: function(startDate, endDate) {
      this.filters.matchesDateFilter.filterValues[0] = {
        name: 'Aktuellt',
        selectedName: 'Aktuellt',
        selected: true
      };
      this.filters.matchesDateFilter.selectedKey = 0;
      var d = startDate;
      var w;
      while (d.isBefore(endDate)) {
        if (d.isoWeek() !== w) {
          w = d.isoWeek();
          var weekName =
            'V ' +
            d.format('w') +
            ': ' +
            d.format('D/M') +
            ' - ' +
            moment(d)
              .endOf('isoWeek')
              .format('D/M');
          this.filters.matchesDateFilter.filterValues[
            d.format('YYYY-MM-DD')
          ] = {
            name: weekName,
            selectedName: 'Vecka ' + d.format('w'),
            selected: false
          };
        }
        d.add(1, 'd');
      }
    },

    selectMenu: function(event) {
      this.removeScrollListener();

      this.showLoader();

      this.disposeMatchViews();

      var selectedVal = $(event.currentTarget).val();

      this.filters[$(event.currentTarget).attr('id')].selectedKey = selectedVal;
      _.each(
        this.filters[$(event.currentTarget).attr('id')].filterValues,
        function(filterValue) {
          filterValue.selected = false;
        }
      );
      this.filters[$(event.currentTarget).attr('id')].filterValues[
        selectedVal
      ].selected = true;

      this.model.setSelection(selectedVal);
    },
    focusMenu: function(event) {
      $(event.currentTarget)
        .find('option')
        .each(function() {
          var obj = $(this);
          obj.text(obj.attr('data-value'));
        });
    },

    blurMenu: function(event) {
      $(event.currentTarget)
        .find('option')
        .each(function() {
          var obj = $(this);
          if (obj.is(':selected')) {
            obj.text(obj.attr('data-text'));
          } else {
            obj.text(obj.attr('data-value'));
          }
        });
    },
    onDestroy: function() {
      this.removeScrollListener();
      this.disposeMatchViews();
      this.filters = null;
    },
    isElementInViewport: function(el) {
      if (el && el instanceof $) {
        el = el.length && el[0];
      }

      if (!el || el.offsetParent === null) {
        return false;
      }

      var rect = el.getBoundingClientRect();

      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
          (window.innerHeight ||
            document.documentElement.clientHeight)  &&
        rect.right <=
          (window.innerWidth ||
            document.documentElement.clientWidth) 
      );
    }
  });
})(Backbone, _, svs);

 })(window);